import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"
import { getStorage } from "firebase/storage";




// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAxDv1xw2669iV-Wfas75F36MvtUO2R6wU",
  authDomain: "bhi-website-api.firebaseapp.com",
  projectId: "bhi-website-api",
  storageBucket: "bhi-website-api.firebasestorage.app",
  messagingSenderId: "251630642220",
  appId: "1:251630642220:web:6079081ef48449d3e21d89"
};

const firebaseImageConfig = {
  apiKey: "AIzaSyCu3fDOT9vaoF_QTMlJIKsEnpXrAmse-x4",
  authDomain: "bhi-product-images.firebaseapp.com",
  projectId: "bhi-product-images",
  storageBucket: "bhi-product-images.firebasestorage.app",
  messagingSenderId: "661519927924",
  appId: "1:661519927924:web:e0d188e069e60b93791f21",
  measurementId: "G-FQ4GZF97F6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig, "Back End App");

const auth = getAuth(app);

const imageApp = initializeApp(firebaseImageConfig, "Image App");

const storage = getStorage(imageApp);

export { auth, storage }
